import Link from "next/link";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const PLATFORM_TERMS_URL = "https://www.attend.tech/terms-of-use";
const PLATFORM_PRIVACY_URL = "https://www.attend.tech/privacy-policy";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "What is the Milwaukee Bucks 414 Season Pass?",
    answer:
      "The Milwaukee Bucks 414 Season Pass is a ticket plan that gives you access to Milwaukee Bucks home games throughout the regular season for one simple price.",
    group: "OVERVIEW",
  },
  {
    question: "How does it work?",
    answer:
      "As a pass holder, you will receive tickets to every regular season home game. Your 414 Season Pass tickets will be available to manage 3 hours prior to tip-off.",
    group: "OVERVIEW",
  },
  {
    question: "Can I purchase additional tickets?",
    answer:
      "Yes, Companion Tickets will be available to purchase on a per game basis. 9:00am the day before the game, pass holders will receive a link to purchase additional tickets.",
    group: "OVERVIEW",
  },
  {
    question: "Are seats guaranteed for every game?",
    answer: "Yes, the 414 Season Pass guarantees a seat for every game.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question: "Where will my seats be?",
    answer:
      "Seat locations are assigned based on availability and may vary from game to game.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question:
      "If I buy two or more passes, will my seats be next to each other?",
    answer: "Yes, passes purchased together will be seated next to each other.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question: "How do I get my tickets?",
    answer: (
      <>
        Tickets will be delivered to your Milwaukee Bucks App/
        <Link target="_blank" href="https://am.ticketmaster.com/bucks/">
          Account Manager
        </Link>{" "}
        3 hours prior to tip-off.
      </>
    ),
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question: "Can I transfer my tickets?",
    answer:
      "Yes, 414 Season Pass holders can transfer tickets. Please contact us if you have questions about attending with a guest.",
    group: "OTHER",
  },
  {
    question: "Can I resale my tickets?",
    answer: "No, 414 Season Pass tickets are not allowed to be resold.",
    group: "OTHER",
  },
  {
    question:
      "If I cannot make a game, can I exchange or refund my 414 Season Pass ticket to that game?",
    answer: "Refunds or exchanges are not available.",
    group: "OTHER",
  },
  {
    question: "Who do I contact with questions?",
    answer:
      "If you have any questions about your pass, use the chat button in the bottom corner of the page to reach our support team.",
    group: "OTHER",
  },
];

export const REGISTRATION_TERMS_AND_CONDITION = () => (
  <>
    By creating an account, you agree to receive account-related notification
    and marketing communication from the Milwaukee Bucks and you confirm that
    you have read and agree to the platform&apos;s{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);

export const TERMS_AND_CONDITION = () => (
  <>
    By checking the box you agree to receive notifications regarding your
    purchase and to the{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);
